export default {
  namespaced: true,
  state: {
    showModal: {
      show: false,
      id: null,
      type: "",
      block_by:null,
      block_to:null,
      profile_object:null
    },
    successModal: {
      show: false,
    },
  },
  getters: {
    getShow: (state) => state.showModal.show,
    getSuccessShow: (state) => state.successModal.show,
  },
  mutations: {
    TOGGLE_MODAL(state, obj) {
      if (obj.show) {
        // console.log("KCH",obj.text)
        state.showModal.block_by = obj.block_by ? obj.block_by : null;
        state.showModal.block_to = obj.block_to ? obj.block_to : null;
        state.showModal.profile_object = obj.profile_object ? obj.profile_object : null;

      }
      state.showModal.show = obj.show;
    },
    TOGGLE_SUCCESS_MODAL(state, obj) {
      state.successModal.show = obj.show;
    },
  },
  actions: {
    toggleModal({ commit }, obj) {
      commit("TOGGLE_MODAL", obj);
    },
    toggleSuccessModal({commit},obj){
        commit("TOGGLE_SUCCESS_MODAL",obj)
    }
  },
};
